var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import I18n from '@utils/i18n';
import api from '@utils/axios';
import EasyUploadLink from '@features/EasyUploadLink';
import { Button, ConfirmDialog } from '@ui';
import { Tooltip } from '@ui/atoms/Tooltip';
import { showErrorToast } from '@ui';
import { inspectionVisitPath } from '@routes';
function EditButton({ trigger }) {
    const label = I18n.t('generic.edit');
    return (React.createElement(Tooltip, { content: label },
        React.createElement(Button, { "data-js-edit-visit-modal-trigger": "true", "data-update-url": trigger.updateUrl, "data-subcontractor-modal": trigger.subcontractorModal, "data-visit": JSON.stringify({
                id: trigger.visit.id,
                technician_id: trigger.visit.technicianId,
                subcontractor_id: trigger.visit.subcontractorId,
                priority: trigger.visit.priority,
                priority_note: trigger.visit.priorityNote,
                scheduled_date: trigger.visit.scheduledDate,
                scheduled_time: trigger.visit.scheduledTime,
                time_zone_override: trigger.visit.timeZoneOverride,
                duration: trigger.visit.duration,
                visit_notes: trigger.visit.visitNotes
            }), "aria-label": label },
            React.createElement("i", { className: "fa-light fa-pencil" }))));
}
function DeleteButton({ visitId }) {
    const [isOpen, setIsOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const title = I18n.t('inspections.show.visits.delete_visit');
    const handleOpen = () => setIsOpen(true);
    const handleCancel = () => {
        if (!deleting)
            setIsOpen(false);
    };
    const handleConfirm = () => __awaiter(this, void 0, void 0, function* () {
        setDeleting(true);
        try {
            yield api.delete(inspectionVisitPath(visitId, { locale: undefined, format: 'json' }));
            window.location.reload();
        }
        catch (error) {
            console.error('[Visit delete] failed', error);
            showErrorToast(I18n.t('generic.error'));
            setDeleting(false);
            setIsOpen(false);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { content: title },
            React.createElement(Button, { "aria-label": title, onClick: handleOpen },
                React.createElement("i", { className: "fa-light fa-trash-can" }))),
        React.createElement(ConfirmDialog, { isOpen: isOpen, title: title, description: I18n.t('inspections.show.visits.delete_confirm'), confirmLabel: I18n.t('generic.delete'), confirmVariant: "danger", loading: deleting, onConfirm: () => void handleConfirm(), onCancel: handleCancel })));
}
export function ActionsCell({ item }) {
    return (React.createElement("div", { className: "visits-table__actions" },
        item.easyUploadProps && (React.createElement(EasyUploadLink, { subcontractWorkStatusId: item.easyUploadProps.subcontractWorkStatusId })),
        item.editTrigger && React.createElement(EditButton, { trigger: item.editTrigger }),
        item.canDelete && React.createElement(DeleteButton, { visitId: item.id })));
}
